export enum PaymentOptionAzure {
  MONTHLY = "MONTHLY",
  UPFRONT = "ALL_UPFRONT",
}
